import { ACTION } from './profile_actions';

const initialState = {
  isLoading: false,
  profile: null,
  isFinding: false,
  account: null,
  errorMessage: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        isLoading: false,
        profile: action.payload,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.FIND}_PENDING`:
      return {
        ...state,
        isFinding: true,
        errorMessage: null,
      };
    case `${ACTION.FIND}_FULFILLED`:
      return {
        ...state,
        isFinding: false,
        account: action.payload.data.pop(),
      };
    case `${ACTION.FIND}_REJECTED`:
      return {
        ...state,
        isFinding: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/profile/profile_reducer.js